import { isEmpty } from 'lodash'

export const removeSpaces = (value) => {
  if (isEmpty(value)) return ''
  return value.replace(/\s+/g, '')
}

export default removeSpaces
